import React, { useRef } from 'react';
import { Player } from 'video-react';
import { useBoolean, useUpdateEffect } from 'ahooks';
import { Modal } from 'antd';
import { Icon } from '@fuxi/eevee-icon';
import { Header, ScrollView } from '@/components';
import { useNav } from '@/hooks';
import playIcon from '@/assets/image/play-icon.png';
import { ALL_PAGES } from '@/constant';
import { useHelpFeedbackStore } from '../store/useHelpFeedbackStore';

import cx from './index.module.scss';

interface Props {}

const VersionUpdateNotice: React.FC<Props> = () => {
  const nav = useNav();
  const bannerList = useHelpFeedbackStore.use.bannerList();
  const helpConfigList = useHelpFeedbackStore.use.helpConfigList();
  const [isDrawerShow, { setTrue: setDrawerShow, setFalse: setDrawerHide }] = useBoolean(false);
  const playerRef = useRef<any>(null);

  useUpdateEffect(() => {
    if (!isDrawerShow) {
      playerRef.current?.video?.pause?.();
    }
  }, [isDrawerShow]);

  return (
    <div className={cx('VersionUpdateNotice')}>
      <Header title="版本更新公告" backConfig={{ text: '返回', action: () => nav(ALL_PAGES.HELP_FEEDBACK) }} />
      <div className={cx('update-content')}>
        <ScrollView autoRefresh className={cx('update-details-img-box')}>
          <div className={cx('update-details-img')}>
            <img src={bannerList?.find(item => item.module === 'versionPoster')?.imageUrl} alt="" />
          </div>
        </ScrollView>
        <div className={cx('update-details-video')}>
          <div className={cx('video-box')} onClick={() => setDrawerShow()}>
            <img
              src={helpConfigList?.find(item => item?.module === 'version')?.setting?.videoCoverImageUrl}
              className={cx('cover-img')}
              alt=""
            />
            <img src={playIcon} className={cx('play-icon')} alt="" />
          </div>
        </div>
      </div>
      <Modal
        getContainer={false}
        closeIcon={null}
        className={cx('modal-wrapper')}
        open={isDrawerShow}
        title={
          <div onClick={setDrawerHide}>
            <Icon className={cx('arrow')} name="arrow-back" />
            <span>更新说明</span>
          </div>
        }
        onCancel={setDrawerHide}
        footer={null}
        maskClosable={false}
        width="100%"
        height="100%"
      >
        <Player
          ref={playerRef}
          poster={helpConfigList?.find(item => item?.module === 'version')?.setting?.videoCoverImageUrl}
          src={helpConfigList?.find(item => item?.module === 'version')?.setting?.videoUrl}
          aspectRatio="16:9"
        />
      </Modal>
    </div>
  );
};

export default VersionUpdateNotice;
